module.exports = __webpack_public_path__ + "static/media/events.bd79fdae.pdf";